module.exports = __webpack_public_path__ + "static/media/js.d4001a69.png";